import { render, staticRenderFns } from "./GreetingPage.vue?vue&type=template&id=1ee1f08c&scoped=true&"
import script from "./GreetingPage.vue?vue&type=script&lang=js&"
export * from "./GreetingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee1f08c",
  null
  
)

export default component.exports